import { useMemo, useState } from "react";
import { clampAmt, entryOf } from "./calculator/calc";
import { SinglePosition } from "./calculator/SinglePosition";
import { Basket } from "./calculator/Basket";

export default function InvestmentCalculator({ assets, compact = false, footer = null, disclaimer, testid = "calc" }) {
  const [mode, setMode] = useState("single");
  const [assetId, setAssetId] = useState(assets[0]?.id);
  const asset = assets.find((a) => a.id === assetId) || assets[0];
  const [entryId, setEntryId] = useState(asset?.entries[0]?.id);
  const entry = entryOf(asset, entryId);
  const [amount, setAmount] = useState(100000);
  const [rows, setRows] = useState(() => [
    { key: 1, assetId: assets[0]?.id, entryId: assets[0]?.entries[0]?.id, amount: 100000 },
  ]);

  const pickAsset = (id) => {
    setAssetId(id);
    const a = assets.find((x) => x.id === id);
    setEntryId(a?.entries[0]?.id);
  };

  const updateRow = (key, patch) => setRows((rs) => rs.map((r) => {
    if (r.key !== key) return r;
    const next = { ...r, ...patch };
    if (patch.assetId) {
      const a = assets.find((x) => x.id === patch.assetId);
      next.entryId = a?.entries[0]?.id;
    }
    return next;
  }));
  const addRow = () => setRows((rs) => [...rs, { key: Date.now(), assetId: assets[0]?.id, entryId: assets[0]?.entries[0]?.id, amount: 50000 }]);
  const removeRow = (key) => setRows((rs) => (rs.length > 1 ? rs.filter((r) => r.key !== key) : rs));

  const totals = useMemo(() => {
    let invested = 0, projected = 0;
    rows.forEach((r) => {
      const a = assets.find((x) => x.id === r.assetId);
      const e = entryOf(a, r.entryId);
      invested += clampAmt(r.amount);
      projected += clampAmt(r.amount) * (e?.multiple || 1);
    });
    return { invested, projected, moic: invested ? projected / invested : 0 };
  }, [rows, assets]);

  if (!assets.length) return <p className="t-small text-muted-s">No data available.</p>;

  return (
    <div data-testid={testid}>
      {!compact && (
        <div className="flex gap-6 mb-8">
          <button onClick={() => setMode("single")} className={`t-label pb-1 border-b ${mode === "single" ? "border-[#E8E6E1] !text-[#E8E6E1]" : "border-transparent hover:!text-[#E8E6E1]"}`} data-testid={`${testid}-mode-single`}>One position</button>
          <button onClick={() => setMode("basket")} className={`t-label pb-1 border-b ${mode === "basket" ? "border-[#E8E6E1] !text-[#E8E6E1]" : "border-transparent hover:!text-[#E8E6E1]"}`} data-testid={`${testid}-mode-basket`}>Build a basket</button>
        </div>
      )}

      {(compact || mode === "single") ? (
        <SinglePosition
          assets={assets} testid={testid} assetId={assetId} asset={asset} entry={entry}
          pickAsset={pickAsset} setEntryId={setEntryId} amount={amount} setAmount={setAmount} />
      ) : (
        <Basket
          assets={assets} testid={testid} rows={rows}
          updateRow={updateRow} addRow={addRow} removeRow={removeRow} totals={totals} />
      )}

      {footer}

      <p className="t-cap text-muted-s mt-8 measure" data-testid={`${testid}-disclaimer`}>
        {disclaimer || "Illustrative only. Figures are approximate and compiled from publicly reported valuations. This is not an offer, a forecast or investment advice. Past performance does not indicate future results. Private investments are illiquid and can lose their entire value."}
      </p>
    </div>
  );
}
